import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/context/LanguageContext";

export function AddressStep({ value, onChange, errors }) {
  const { t } = useLanguage();
  const a = t.address;
  const set = (k, v) => onChange({ ...value, [k]: v });

  return (
    <div className="space-y-6" data-testid="step-address-content">
      <div>
        <h2 className="text-3xl font-black tracking-tight md:text-4xl">
          {a.title}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">{a.description}</p>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="md:col-span-2">
          <Field id="street" label={a.street} required error={errors?.street_address}>
            <Input
              id="street"
              data-testid="address-street"
              value={value.street_address || ""}
              onChange={(e) => set("street_address", e.target.value)}
              className="h-12"
            />
          </Field>
        </div>
        <Field id="apartment" label={a.apartment}>
          <Input
            id="apartment"
            data-testid="address-apartment"
            value={value.apartment || ""}
            onChange={(e) => set("apartment", e.target.value)}
            className="h-12"
          />
        </Field>
        <Field id="city" label={a.city} required error={errors?.city}>
          <Input
            id="city"
            data-testid="address-city"
            value={value.city || ""}
            onChange={(e) => set("city", e.target.value)}
            className="h-12"
          />
        </Field>
        <Field id="state" label={a.state} required error={errors?.state}>
          <Input
            id="state"
            data-testid="address-state"
            value={value.state || ""}
            onChange={(e) => set("state", e.target.value)}
            className="h-12"
          />
        </Field>
        <Field id="zip" label={a.zip} required error={errors?.zip_code}>
          <Input
            id="zip"
            data-testid="address-zip"
            value={value.zip_code || ""}
            onChange={(e) => set("zip_code", e.target.value)}
            className="h-12 font-mono"
          />
        </Field>
        <Field id="country" label={a.country} required error={errors?.country}>
          <Input
            id="country"
            data-testid="address-country"
            value={value.country || ""}
            onChange={(e) => set("country", e.target.value)}
            className="h-12"
          />
        </Field>
      </div>
    </div>
  );
}

function Field({ id, label, required, error, children }) {
  return (
    <div className="flex flex-col gap-2">
      <Label
        htmlFor={id}
        className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground"
      >
        {label}
        {required && <span className="ml-1 text-[hsl(var(--warning))]">*</span>}
      </Label>
      {children}
      {error && (
        <p className="text-[11px] text-destructive" aria-live="polite">
          {error}
        </p>
      )}
    </div>
  );
}
